import type { PlayerConfig } from './player.config';
import { usePlayerOptions } from './hooks/use-player-options';
import { VideoJS } from './videojs';

export const Player = (props: PlayerConfig) => {
  const playerOptions = usePlayerOptions(props);

  return <VideoJS options={playerOptions} />;
};
